/* Mr Pixel v2 header: Buy mega menu, Services drop, phone drawer.
 * Click toggles a panel everywhere; on a hover device at 1024+ the pointer also opens it, with a
 * short delay each way so a diagonal move to the panel doesn't close it. Escape or a click
 * outside closes. The drop is placed under its own button (the board pins it by hand). */
// Footer "Back to top" (client meeting 2026-10-04): a smooth scroll, not a jump. Lives here because
// the header script loads on every page. Focus goes to the top too, for keyboard users.
document.addEventListener('click', (e) => {
  const a = e.target.closest && e.target.closest('[data-mp2-totop]');
  if (!a) return;
  e.preventDefault();
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top: 0, behavior: still ? 'auto' : 'smooth' });
  const first = document.querySelector('[data-mp2-header] a[href]');
  if (first) first.focus({ preventScroll: true });
});

(() => {
  const root = document.querySelector('[data-mp2-header]');
  if (!root) return;
  const masthead = root.querySelector('.masthead');
  const buttons = [...root.querySelectorAll('[data-mp2-menu]')];
  const hover = window.matchMedia('(hover: hover) and (min-width: 1024px)');
  const panelOf = (b) => document.getElementById(b.getAttribute('aria-controls'));
  let open = null;
  let openedByHover = 0;
  let timer;

  function place(b, p) {
    if (!p.classList.contains('drop')) return;
    const m = masthead.getBoundingClientRect();
    const r = b.getBoundingClientRect();
    const half = p.offsetWidth / 2;
    const centre = Math.min(Math.max(r.left + r.width / 2 - m.left, half + 12), m.width - half - 12);
    p.style.left = centre + 'px';
  }

  // Panels fade and drop in rather than appearing at once (client meeting 2026-10-04): `hidden`
  // comes off first, .mp2-in on the next frame starts the transition (glue.css); on close
  // .mp2-in goes and `hidden` returns once the fade is done, unless it was reopened meanwhile.
  function hidePanel(p) {
    p.classList.remove('mp2-in');
    clearTimeout(p._mp2Hide);
    p._mp2Hide = setTimeout(() => { if (!p.classList.contains('mp2-in')) p.hidden = true; }, 220);
  }
  function showPanel(p) {
    clearTimeout(p._mp2Hide);
    p.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => p.classList.add('mp2-in')));
  }

  function close() {
    if (!open) return;
    open.setAttribute('aria-expanded', 'false');
    hidePanel(panelOf(open));
    open = null;
  }

  function show(b, byHover) {
    if (open === b) return;
    close();
    const p = panelOf(b);
    showPanel(p);
    place(b, p);
    b.setAttribute('aria-expanded', 'true');
    open = b;
    openedByHover = byHover ? Date.now() : 0;
  }

  buttons.forEach((b) => {
    b.addEventListener('click', () => {
      // a click right after a hover-open confirms it rather than closing it again
      if (open === b && Date.now() - openedByHover > 400) close();
      else show(b, false);
    });
    [b, panelOf(b)].forEach((el) => {
      el.addEventListener('mouseenter', () => {
        if (!hover.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => show(b, true), 90);
      });
      el.addEventListener('mouseleave', () => {
        if (!hover.matches) return;
        clearTimeout(timer);
        timer = setTimeout(close, 240);
      });
    });
  });

  document.addEventListener('click', (e) => {
    if (open && !e.target.closest('.navrow, .mega, .drop')) close();
  });

  // phone drawer
  const burger = root.querySelector('[data-mp2-burger]');
  const drawer = document.getElementById('mp2-menu-drawer');
  const icon = burger && burger.querySelector('use');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  function drawerTo(state) {
    if (!drawer) return;
    burger.setAttribute('aria-expanded', String(state));
    if (icon) icon.setAttribute('href', state ? '#mp2-close' : '#mp2-menu');
    if (drawer._mp2Out) { drawer._mp2Out.cancel(); drawer._mp2Out = null; }
    // Round 16: it opens with mp2p-drop (polish.css); it now leaves the same way instead of vanishing
    if (!state && !drawer.hidden && drawer.animate && !still.matches) {
      const a = drawer.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-6px)' }],
        { duration: 200, easing: 'cubic-bezier(.4,0,1,1)' });
      drawer._mp2Out = a;
      const done = () => { if (drawer._mp2Out !== a) return; clearTimeout(t); drawer.hidden = true; drawer._mp2Out = null; };
      const t = setTimeout(done, 260);   // frames can be paused (background tab): it still closes
      a.onfinish = done;
      return;
    }
    drawer.hidden = !state;
  }
  // toggle on the button's state: during the fade-out the drawer is still un-hidden, so a tap there reopens it
  if (burger) burger.addEventListener('click', () => drawerTo(burger.getAttribute('aria-expanded') !== 'true'));
  window.matchMedia('(min-width: 1024px)').addEventListener('change', (e) => {
    if (e.matches) drawerTo(false);
    else close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (open) {
      const b = open;
      close();
      b.focus();
    } else if (drawer && !drawer.hidden) {
      drawerTo(false);
      burger.focus();
    }
  });
})();

/* Round 6 (Jordan 2026-10-04): the FAQ and Contact accordions glide open and shut instead of snapping.
   One delegated handler (this file loads on every page with the header). Native <details> stays the
   source of truth, so it still works with no JS, and find-in-page can still open a closed answer. */
(() => {
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  // + the product page's accordions (polish audit P-05, 2026-10-04)
  // Round 16: the product rows are mp-accordion's (mp-accordion.js animates them); running both made a row
  // open, start closing on its text, then snap back. Only a product row without it is ours. + the phone menu.
  const SEL = '.mp2 details.acc2, .mp2 .mp2-cfaq details, .product__accordion:not(.mp-accordion) details, .mp2 .drawer details';
  function heights(d) {
    const was = d.open;
    d.open = false; const shut = d.offsetHeight;
    d.open = true; const full = d.offsetHeight;
    d.open = was;
    return { shut, full };
  }
  document.addEventListener('click', (e) => {
    const s = e.target.closest('summary');
    const d = s && s.parentElement;
    if (!d || !d.matches(SEL) || still.matches || !d.animate) return;
    e.preventDefault();
    if (d._mp2Anim) d._mp2Anim.cancel();
    const opening = !d.open;
    const { shut, full } = heights(d);
    d.open = true;
    d.classList.toggle('is-closing', !opening);
    d.style.overflow = 'hidden';
    const a = d.animate({ height: opening ? [shut + 'px', full + 'px'] : [full + 'px', shut + 'px'] },
      { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' });
    d._mp2Anim = a;
    a.onfinish = () => {
      d.open = opening;
      d.classList.remove('is-closing');
      d.style.overflow = '';
      d._mp2Anim = null;
    };
    a.oncancel = () => { d.classList.remove('is-closing'); d.style.overflow = ''; };
  });
})();
